import { Controller } from "stimulus"

export default class extends Controller {
	static targets = ["input", "item", "noResults"]

	connect() {
		this.filter()
	}

	filter() {
		const query = this.inputTarget.value.toLowerCase().trim()
		let visibleCount = 0

		this.itemTargets.forEach((element) => {
			const providerName = (element.dataset.providerName || "").toLowerCase()
			const shouldShow = query === "" || providerName.includes(query)

			element.classList.toggle("d-none", !shouldShow)
			if (shouldShow) visibleCount += 1
		})

		if (this.hasNoResultsTarget) {
			this.noResultsTarget.classList.toggle("d-none", visibleCount > 0)
		}
	}

	clear() {
		if (!this.hasInputTarget) return

		this.inputTarget.value = ""
		this.filter()
	}
}
